import React from "react";
import {Button, Dialog, DialogActions, DialogContent, Typography} from "@mui/material";

const LeaveDataModal = (props) => {
    const { handleCancel, handleLeave, open } = props;


    return (
        <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogContent style={{ margin: "auto" }}>
                <Typography>You have unsaved changes. Are you sure you want to leave this page?</Typography>
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleLeave}>
                    Leave
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LeaveDataModal;